import store from 'redux/store'
import * as Actions from 'redux/actions'
import { sendToApi } from 'api/client'
import { CardDismissal } from 'types'

export const CardDismissalService = {
  createCardDismissal: async (cardIdentifier: CardDismissal) => {
    const { auth, workspace } = store.getState()

    store.dispatch(Actions.createCardDismissal(cardIdentifier))

    return sendToApi<{ card_dismissal: CardDismissal }>(`/users/${auth?.id}/card_dismissals.json`, {
      method: 'POST',
      body: {
        workspace_id: workspace?.currentWorkspaceId,
        identifier: cardIdentifier,
      },
    })
  },

  deleteCardDismissal: async (cardIdentifier: CardDismissal) => {
    const { auth, workspace } = store.getState()

    return sendToApi<{}>(`/users/${auth?.id}/card_dismissals/${cardIdentifier}`, {
      method: 'DELETE',
      body: {
        workspace_id: workspace?.currentWorkspaceId,
      },
    })
  },

  getCardDismissal: async (cardIdentifier: CardDismissal, byWorkspace = true) => {
    const { auth, workspace } = store.getState()

    let url = `/users/${auth?.id}/card_dismissals/is_dismissed?identifier=${cardIdentifier}`
    if (byWorkspace) {
      url += `&workspace_id=${workspace?.currentWorkspaceId}`
    }

    return sendToApi<{ is_dismissed: boolean }>(url)
  },

  isDismissed: (cardIdentifier: CardDismissal) => {
    const { cardDismissals } = store.getState()
    return cardDismissals?.includes(cardIdentifier)
  },
}
